export enum MessageType {
    Value,
    Error,
    Complete,
}

export interface ValueMessage<V = any> {
    type: MessageType.Value
    value: V
}
export interface CompleteMessage<C = any> {
    type: MessageType.Complete
    complete: C
}

export interface ErrorMessage<E = any> {
    type: MessageType.Error
    error: E
}

export type Message<V = any, E = any, C = any> = ValueMessage<V> | CompleteMessage<C> | ErrorMessage<E>

export type AnyMessage = Message<any, any, any>
export type EmptyMessage = Message
